import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import FlightPlanner from './pages/FlightPlanner';
import OperationsDashboard from './pages/OperationsDashboard';
import UserManagement from './pages/UserManagement';
import EnquiriesManagement from './pages/EnquiriesManagement';
import EventManagement from './pages/EventManagement';

// Service Pages
import VipCharter from './pages/services/VipCharter';
import CorporateCharter from './pages/services/CorporateCharter';
import ElectionFlying from './pages/services/ElectionFlying';
import EmsOrganTransport from './pages/services/EmsOrganTransport';
import FlowerDrop from './pages/services/FlowerDrop';
import WeddingEntry from './pages/services/WeddingEntry';
import TempleHeritage from './pages/services/TempleHeritage';
import JoyRides from './pages/services/JoyRides';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            
            {/* Service Pages - Public */}
            <Route path="/services/vip-charter" element={<VipCharter />} />
            <Route path="/services/corporate-charter" element={<CorporateCharter />} />
            <Route path="/services/election-flying" element={<ElectionFlying />} />
            <Route path="/services/ems-organ-transport" element={<EmsOrganTransport />} />
            <Route path="/services/flower-drop" element={<FlowerDrop />} />
            <Route path="/services/wedding-entry" element={<WeddingEntry />} />
            <Route path="/services/temple-heritage" element={<TempleHeritage />} />
            <Route path="/services/joy-rides" element={<JoyRides />} />
            
            {/* Hidden Admin/Team Login Route */}
            <Route path="/adminhighkraft" element={<Login />} />
            
            {/* Protected Operations Routes */}
            <Route
              path="/operations"
              element={
                <ProtectedRoute>
                  <OperationsDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/operations/flight-planner"
              element={
                <ProtectedRoute>
                  <FlightPlanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/operations/enquiries"
              element={
                <ProtectedRoute>
                  <EnquiriesManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/operations/events"
              element={
                <ProtectedRoute>
                  <EventManagement />
                </ProtectedRoute>
              }
            />
            
            {/* Admin Only Routes */}
            <Route
              path="/operations/admin/users"
              element={
                <ProtectedRoute adminOnly={true}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;